import React, { Component } from "react";
import TableActions from "./TableActions";
import "react-sortable-tree/style.css"; // This only needs to be imported once in your app
import SortableTree, {
  toggleExpandedForAll,
  removeNodeAtPath,
  addNodeUnderParent,
} from "react-sortable-tree";
import { isDescendant } from "react-sortable-tree";
import Minimalistic from "react-sortable-tree-theme-minimal";
import { checkNotUndefindeNull } from "../../../../Templates/functions";
import { getNodeAtPath, find, getFlatDataFromTree } from "react-sortable-tree";
import { createWipStep, deleteWipStep } from "../../../../../util/wi_util";
const ObjectID = require("bson-objectid");
class TableOfContents extends Component {
  state = {
    searchString: "", // Stores the search string for filtering the tree.
    searchFocusIndex: 0, // The current search result index.
    searchFoundCount: null, // Total number of search results.
    treeData: this.props.steps, // Initial tree data.
    newTreeData: [], // New tree data.
    currentSelectedNode: null, // Currently selected node in the tree.
    currentSelectedNodePath: null, // Path of the selected node.
    idToIndexMap: {}, // Mapping from node IDs to their indices in the tree data.
  };
  // -------------------------------------------------------------- Lifecycle method --------------------------------------------------------------//

  componentDidUpdate = (prevProps, prevState) => {
    // If a new step was selected, expand the tree to show it
    if (
      prevProps.selectedStepId !== this.props.selectedStepId &&
      this.props.selectedStepId
    ) {
      this.expandToStep(this.props.selectedStepId);
    }

    // Sync internal tree when parent steps change (ensures immediate UI updates without refresh)
    if (prevProps.steps !== this.props.steps) {
      this.setState({ treeData: this.props.steps });
    }
  };
  // -------------------------------------------------------------- Lifecycle method --------------------------------------------------------------//

  componentDidMount = (prevProps, prevState) => {
    const idToIndexMap = {};
    this.state.treeData.forEach((step, index) => {
      const stepId = step._id;
      idToIndexMap[stepId] = index;
    });

    this.setState({ idToIndexMap });
    this.expandAll();
  };

  getNodeKey = ({ node }) => node._id;
  
  // -------------------------------------------------------------- Calculate step number in hierarchy --------------------------------------------------------------//
  
  calculateStepNumber = (treeData, parentKey) => {
    // Helper to recursively calculate step numbers
    const findStepNumber = (steps, targetParentKey, prefix = '') => {
      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        const currentNumber = prefix ? `${prefix}.${i + 1}` : `${i + 1}`;
        
        // If this step is the parent we're looking for, return the next child number
        if (step._id === targetParentKey) {
          const childCount = step.children ? step.children.length : 0;
          return `${currentNumber}.${childCount + 1}`;
        }
        
        // Recursively search in children
        if (step.children && step.children.length > 0) {
          const result = findStepNumber(step.children, targetParentKey, currentNumber);
          if (result) return result;
        }
      }
      return null;
    };
    
    // If no parent (top-level step), just count top-level steps
    if (!parentKey || parentKey === null) {
      return `${treeData.length + 1}`;
    }
    
    // Find the step number for a substep
    return findStepNumber(treeData, parentKey) || 'New Step';
  };
  
  // -------------------------------------------------------------- Get parent node --------------------------------------------------------------//

  getParentNode = (t) => {
    let search = this.props.getPath().flat(Infinity);
    let parentNode = find({
      searchQuery: search[search.length - 1],
      searchMethod: ({ node, searchQuery }) => node._id == searchQuery,
      expandAllMatchPaths: false,
      expandFocusMatchPaths: true,
      getNodeKey: this.getNodeKey,
      searchFocusOffset: 0,
      treeData: t,
    }).matches[0];
    return parentNode;
  };
  // -------------------------------------------------------------- This creates a Substep --------------------------------------------------------------//

  customAddNodeUnderParent = () => {
    // Ensure any in-progress editor changes are saved first
    if (this.props.beforeAddStep) {
      try { this.props.beforeAddStep(); } catch (e) {}
    }
    // Use latest steps from parent to avoid overwriting recent edits
    let t = this.props.getSteps();
    let order = this.props.selectedStep.children.length + 1;
    let parentNode = this.getParentNode(t);
    let parentKey = this.getNodeKey(parentNode);
    if (parentKey == -1) {
      parentKey = null;
    }
    
    // Calculate the step number for the new substep
    const stepNumber = this.calculateStepNumber(t, parentKey);
    
    createWipStep(
      {
        title: stepNumber,
        WIPID: this.props.WIPID,
        name: "",
        requiresOversight: 0,
        requiresVerification: 0,
        timeEstimation: { days: 0, hours: 0, minutes: 0 },
        content: "",
        sequence: "",
        has_children: 0,
        is_child: 1,
        parent_step: parentKey,
        order: order,
      },
      parentKey
    )
      .then((createdStep) => {
        let newNode = {
          _id: createdStep._id,
          title: createdStep.title || stepNumber,
          children: [],
          requiresOversight: false,
          requiresVerification: false,
          timeEstimation: { days: 0, hours: 0, minutes: 0 },
          content: "",
          attachments: [],
          order: order,
        };
        let treeData = addNodeUnderParent({
          treeData: t,
          newNode,
          expandParent: true,
          parentKey: parentKey,
          getNodeKey: this.getNodeKey,
        }).treeData;

        let newPath = [...this.props.path, newNode._id];

        this.setState({ treeData }, () => {
          this.props.updateSteps(treeData, newNode, false, false, true, true);
          this.props.selectStep(newNode, newPath);
          this.expandToStep(newNode._id);
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  // -------------------------------------------------------------- This creates a Step --------------------------------------------------------------//

  addSibling = () => {
    // Ensure any in-progress editor changes are saved first
    if (this.props.beforeAddStep) {
      try { this.props.beforeAddStep(); } catch (e) {}
    }
    // Use latest steps from parent to avoid overwriting recent edits (e.g., attachments)
    let t = this.props.getSteps();
    let order = t.length + 1;
    let path = this.props.path;
    let parentStep = null;
    if (path && path.length >= 2) {
      parentStep = path[path.length - 2];
    }
    
    // Calculate the step number for the new sibling step
    const stepNumber = this.calculateStepNumber(t, parentStep);
    
    createWipStep(
      {
        title: stepNumber,
        WIPID: this.props.WIPID,
        name: "",
        requiresOversight: 0,
        requiresVerification: 0,
        timeEstimation: { days: 0, hours: 0, minutes: 0 },
        content: "",
        sequence: "",
        has_children: 0,
        is_child: parentStep == null ? 0 : 1,
        parent_step: parentStep,
        order: order,
      },
      parentStep
    )
      .then((createdStep) => {
        const newNode = {
          _id: createdStep._id,
          title: createdStep.title || stepNumber,
          children: [],
          requiresOversight: false,
          requiresVerification: false,
          timeEstimation: { days: 0, hours: 0, minutes: 0 },
          content: "",
          attachments: [],
          order: order,
        };

        const treeData = addNodeUnderParent({
          treeData: t,
          newNode,
          parentKey: createdStep.parent_step,
          //parentKey : parentKey,
          expandParent: true,
          getNodeKey: this.getNodeKey,
        }).treeData;

        const newPath = [...this.props.path];

        if (newPath.length > 0) {
          newPath.pop();
          newPath.push(newNode._id);
        } else {
          newPath.push(newNode._id);
        }

        this.setState(
          {
            treeData: treeData,
            currentSelectedNodePath: newPath,
            currentSelectedNode: newNode,
          },
          () => {
            this.props.updateSteps(
              treeData,
              newNode,
              false,
              false,
              false,
              true
            );
            this.props.selectStep(newNode, newPath);
            this.expandToStep(newNode._id);
          }
        );
      })
      .catch((err) => {
        console.error(err);
      });
  };
  // --------------------------------------------------------------Function called when a node is dragged. --------------------------------------------------------------//
  onMoveNode = ({
    nextParentNode,
    nextPath,
    nextTreeIndex,
    node,
    path,
    prevPath,
    prevTreeIndex,
    treeData,
    treeIndex,
  }) => {
    this.props.updateTree(treeData, node);
  };

  updateStepOrder = (treeData) => {
    const stepLoop = (steps) => {
      for (let i = 1; i <= steps.length; i++) {
        steps[i].order = i;
        if (steps[i].children.length > 0) {
          stepLoop(steps[i].children);
        }
      }
    };

    for (let i = 1; i <= treeData.length; i++) {
      treeData[i].order = i;
      if (treeData[i].children.length > 0) {
        stepLoop(treeData[i].children);
      }
    }
    return treeData;
  };
  // -------------------------------------------------------------- Function to determine the appropriate path based on various conditions --------------------------------------------------------------//

  returnPath = (path, sib, del) => {
    if (Array.isArray(path)) {
      if (sib) {
        if (path && path.length >= 2) {
          return path[path.length - 2];
        } else {
          return null;
        }
      } else {
        return path[path.length - 1];
      }
    }
    if (del) {
      return [path];
    }
    return path;
  };
  // -------------------------------------------------------------- This deletes a Step or Sub-Step --------------------------------------------------------------//

  removeNode = () => {
    let search = getFlatDataFromTree({
      treeData: this.state.treeData,
      getNodeKey: this.getNodeKey,
      ignoreCollapsed: false,
    });
    if (search.length === 1) {
      alert("Every work instruction must have at least one step.");
      return;
    }
    let confirmation = false;
    let t = this.props.getSteps();
    let numSubSteps = this.props.selectedStep.children
      ? this.props.selectedStep.children.length
      : 0;
    confirmation = window.confirm(
      `You are about to delete a step ${
        numSubSteps ? `and ${numSubSteps} sub steps` : ``
      }. Upon saving this action cannot be undone, would you like to proceed?`
    );

    if (!confirmation) {
      return;
    }
    deleteWipStep(this.props.selectedStep)
      .then((data) => {
        // Resolve a fresh path for the currently selected step to avoid using a stale path
        const selectedId = this.props.selectedStepId || (this.props.selectedStep && this.props.selectedStep._id);
        let resolvedPath = this.state.currentSelectedNodePath;
        try {
          const res = find({
            searchQuery: selectedId,
            searchMethod: ({ node, searchQuery }) => node._id === searchQuery,
            getNodeKey: this.getNodeKey,
            treeData: t,
          });
          if (res && res.matches && res.matches[0] && res.matches[0].path) {
            resolvedPath = res.matches[0].path;
          }
        } catch (e) {
          // Fallback to existing path if resolution fails
        }

        let treeData = removeNodeAtPath({
          treeData: t,
          path: resolvedPath,
          getNodeKey: this.getNodeKey,
          ignoreCollapsed: false,
          expanded: true,
        });

        if (treeData.length === 0) {
          return this.setState({ treeData }, () => this.addSibling());
        }
        this.setState({ treeData }, () => {
          this.props.updateSteps(treeData, false, false, true);
          this.props.stepDeleted();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // -------------------------------------------------------------- Function for expanding or collapsing nodes in the tree --------------------------------------------------------------//

  expand(expanded) {
    this.setState({
      treeData: toggleExpandedForAll({
        treeData: this.state.treeData,
        expanded,
      }),
    });
  }
  // --------------------------------------------------------------Function to expand all nodes in the tree --------------------------------------------------------------//

  expandAll = () => {
    this.expand(true);
  };
  // -------------------------------------------------------------- Function to collapse all nodes in the tree --------------------------------------------------------------//

  collapseAll = () => {
    this.expand(false);
  };

  // -------------------------------------------------------------- Function to expand tree to show a specific step --------------------------------------------------------------//

  expandToStep = (stepId) => {
    // Use react-sortable-tree's find function to locate and expand to the step
    const result = find({
      searchQuery: stepId,
      searchMethod: ({ node, searchQuery }) => node._id === searchQuery,
      expandAllMatchPaths: true, // This will expand all paths to show the matching node
      expandFocusMatchPaths: true,
      getNodeKey: this.getNodeKey,
      treeData: this.state.treeData,
    });

    if (result && result.treeData) {
      this.setState({ treeData: result.treeData });
    }
  };
  // -------------------------------------------------------------- Function to update the tree structure --------------------------------------------------------------//

  updateTree = (treeData, withClearData) => {
    this.setState(
      { treeData },
      this.props.updateTree(treeData, null, withClearData)
    );
  };
  // -------------------------------------------------------------- Function to handle submission of a new step --------------------------------------------------------------//

  handleNewStepSubmit = (e, formData) => {
    e.preventDefault();
    this.props.addStep(formData);
    this.setState({ addingStep: false });
  };
  // -------------------------------------------------------------- Function to scroll to a selected step in the tree --------------------------------------------------------------//

  focusScroll = () => {
    if (this.props.selectedStep) {
      let step = document.getElementsByClassName(
        `step-${this.props.selectedStep._id}`
      )[0];
      if (step) {
        step.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };
  // -------------------------------------------------------------- Render method to display the component --------------------------------------------------------------//

  render() {
    const { treeData, searchString, searchFocusIndex, searchFoundCount } =
      this.state;
    // -------------------------------------------------------------- Logic to select the previous search result --------------------------------------------------------------//

    const selectPrevMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
            : searchFoundCount - 1,
      });
    // -------------------------------------------------------------- Logic to select the next search result --------------------------------------------------------------//

    const selectNextMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFocusIndex + 1) % searchFoundCount
            : 0,
      });
    // -------------------------------------------------------------- JSX structure for rendering the component --------------------------------------------------------------//

    return (
      <div id="table-of-contents-container" className="overflow ">
        <div className="flex-column max-size">
          <div className="flex-apart" id="author-toc-header-container">
            {this.props.toolbar}
          </div>
          <div style={{ flex: "0 0 auto", padding: "0 .5" }}></div>
          <div style={{ flex: "1 0 50%", overflowX: "hidden" }}>
            {/* ----------------------------------------------------------------------------- SORTABLE TREE HERE ----------------------------------------------------------------------------- */}
            <SortableTree
              scaffoldBlockPxWidth={22}
              treeData={treeData}
              isVirtualized={false}
              onChange={this.updateTree}
              onMoveNode={this.onMoveNode}
              generateNodeProps={({ node, path }) => {
                return {
                  onClick: () => {
                    this.props.selectStep(node, path);
                    let blueBar = document.getElementById("stepContentBlueBar");
                    if (checkNotUndefindeNull(blueBar)) {
                      if (blueBar.children.length > 0) {
                        blueBar.removeChild(blueBar.firstChild);
                      }
                    }
                    this.setState({
                      currentSelectedNode: node,
                      currentSelectedNodePath: path,
                    });
                  },

                  className: `${
                    this.props.selectedStepId === node._id
                      ? "selected-container"
                      : ""
                  } step-${node._id} parent-${node.parent_step}`,
                };
              }}
              getNodeKey={this.getNodeKey}
              theme={Minimalistic}
              searchQuery={searchString}
              searchFocusOffset={searchFocusIndex}
              style={{ width: "100%", fontWeight: "normal", fontSize: "15px" }}
              rowHeight={36}
              searchFinishCallback={(matches) =>
                this.setState({
                  searchFoundCount: matches.length,
                  searchFocusIndex:
                    matches.length > 0 ? searchFocusIndex % matches.length : 0,
                })
              }
              canDrag={({ node }) => !node.dragDisabled}
            />
          </div>
          <TableActions
            removeStep={this.removeNode}
            addStep={this.addSibling}
            // addStep={this.customAddNodeUnderParent}
            addSubstep={this.customAddNodeUnderParent}
            // addSubstep={this.addSibling}
            selectedStep={this.props.selectedStep}
            isActive={this.props.selectedStep}
            onLastStep={this.props.steps.length === 1}
          />
        </div>
      </div>
    );
  }
}

export default TableOfContents;